export default "/assets/images/screen-02.33e7f8a59f6c1815.png";